import { FC } from "react";
import { ProgramStructure2Data } from "./_schema";
import { cn } from "@/lib/utils";

// Description Component
export const Description: FC<{ parsedData: ProgramStructure2Data }> = ({ parsedData }) => (
    <p
        className={cn(
            "font-semibold leading-[1.49] mb-[24px]",
            "text-[14px] w-full",
            "sm:text-[12px] sm:w-[720px] sm:mb-[20px]",
            "md:text-[14px] md:w-[830px] md:mb-[28px]",
            "lg:text-[16px] lg:w-[966px] lg:mb-[28px]",
            "xl:text-[16px] xl:w-[966px] xl:mb-[28px]"
        )}
        style={{
            color: parsedData.description_color || "rgba(255, 255, 255, 0.7)",
            fontFamily: "var(--font-google-sans)"
        }}
    >
        {parsedData.description}
    </p>
);
